<!--  -->
<template>
  <div class="detail">
    <div class="header">
      <!-- <img src="../../assets/khk-003b.jpg" alt="banner" class="banner" /> -->
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo" />
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back2.png" alt="back" />
        </router-link>
      </div>
    </div>

    <div class="content">
      <div class="top">{{ productInfo.product_type_name }}</div>
      <div class="mid">
        <div class="img">
          <img :src="productInfo.product_details_image" alt="" />
        </div>

        <div
          class="mask_content"
          v-html="productInfo && productInfo.product_details_describe"
        >
          {{ productInfo && productInfo.product_details_describe }}
        </div>
      </div>

      <div class="bottom">
        <div class="line"></div>
        <div class="img">
          <img :src="productInfo.product_details_specification_image" alt="" />
        </div>
        <div class="footer">
          <p>Copyright © 2020 sh-million.com All Rights Reserved</p>
          <a href="https://beian.miit.gov.cn/"
            >版权所有·上海米仑 沪ICP备2015606号-1</a
          >
          <p style="color: yellow; font-size: 16px">
            电话：
            <span style="color: yellow">021-56523831</span>
          </p>
          <p>地址：上海市宝山区高境镇共和新路4727号新陆国际商务大厦805室</p>
          <p>
            主营产品：KHK齿轮-KHK齿条-斜齿轮-锥齿轮-蜗轮蜗杆-齿轮箱-棘轮棘爪-行星齿轮结构组
          </p>
        </div>
      </div>
    </div>
    <div class="banner_img">
      <img src="../../assets/blo6.png" alt />
    </div>
    <!-- <div class="banner_img_1">
      <img src="../../assets/blo7.png" alt />
    </div> -->
    <!-- <mb-fotter></mb-fotter> -->

    <!-- <div class="content">
      <div class="left">
        <div class="top">{{ productInfo.product_type_name }}</div>
        <div class="mid">
          <img :src="productInfo.product_details_image" alt="" />
        </div>
        <div class="bottom">
          <img :src="productInfo.product_details_specification_image" alt="" />
        </div>
      </div>
     
    </div> -->

    <!-- <mb-fotter></mb-fotter> -->
  </div>
</template>

<script>
// import mbFotter from '../../components/moblie-fotter.vue';
import request from "../../server/request.js";

// import mbHeader from "../../components/moblie-header.vue";
// import backTop from "../../components/back-top.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    // mbFotter,
    // mbHeader,
    // backTop,
  },

  data() {
    //这里存放数据
    return {
      productInfo: [],
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {},

  //方法集合
  methods: {},

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log(this.$route.params.guid);
    console.log(this.$route.query);
    request.getProductsByGuid(this.$route.params.guid, (res) => {
      this.productInfo = res.data[0];

      if (!res.data[0].is_replenish_details) {
        this.$router.push({ path: "/" });
      } else {
        document.title = res.data[0].product_seo_tag;
      }
    });
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="less">
#app {
  background: #ffffff;
  height: 100%;
}
.detail {
  position: relative;
  background-image: url("../../assets/detail2.png");
  // display: flex;
  // flex-direction: column;
  .header {
    .banner {
      width: 100%;
      background-size: 100% 100%;
      vertical-align: top;
    }
    .nav {
      background: #ffffff;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0.3rem 1rem;
      border-bottom: 2px solid #0583c9;
      .back {
        color: #0583c9;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }
  }

  .banner_img {
    position: absolute;
    right: 0;
    bottom: 0.8rem;
  }
  // .banner_img_1 {
  //   position: absolute;
  //   left: 0;
  //   bottom: 1rem;
  // }
  //  .left-banner {
  //    height: 100%;
  //    width: 100%;
  //    background-image: url('../../assets/blo6.png');
  //    background-size: cover;

  //  }
  //  .right-banner {
  //      height: 100%;
  //    width: 100%;
  //  background-image: url('../../assets/blo7.png');
  //   background-size: cover;
  //  }
  .footer {
    background: #054183;
    position: absolute;
    bottom: 0;
    // left: 0;
    z-index: 10;
    width: 100%;
    // height: 1.6rem;
    padding: 0.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin: 0.08rem 0;
      color: #fcfdfd;
      font-size: 0.12rem;
      line-height: 1;
    }

    a {
      margin: 0.16rem 0;
      color: #fcfdfd;
      font-size: 14px;
      line-height: 1;
      :hover {
        margin: 0.16rem 0;
        color: #fcfdfd;
        font-size: 14px;
        line-height: 1;
      }
    }
  }

  .content {
    position: relative;
    top: 73px;
    width: 100%;
    .top {
      width: 45%;
      height: 55px;
      margin: 0 2rem;
      border: 2px solid #0583c9;
      border-radius: 5px;
      line-height: 55px;
      background: rgba(5, 131, 201, 1);
      display: flex;
      font-size: 0.5rem;
      font-family: SourceHanSansSC;
      font-weight: bold;
      color: #ffffff;
      text-indent: 0.5rem;
    }
    .mid {
      width: 100%;
      display: flex;
      padding: 0.5rem 2rem;
      box-sizing: border-box;
      z-index: 999;
      .img {
        width: 30%;
        img {
          width: 100%;
          // background-size: cover;
        }
      }
      .mask_content {
        width: 70%;
        padding: 0 1rem;
        p {
          min-height: 16px;
          white-space: pre;
        }
      }
    }

    .bottom {
      position: relative;
      width: 100%;
      .line {
        width: 100%;
        height: 1px;
        background: #0583c9;
        border: 0.5px solid #0583c9;
        margin-bottom: 0.5rem;
      }
      .img {
        width: 75%;
        margin: 0.5rem 2rem;
        margin-bottom: 0;
        // box-sizing: border-box;
        img {
          width: 100%;
          //  background-size: cover;
        }
      }
      .footer {
        background: #054183;
        position: relative;
        bottom: 0;
        // left: 0;
        z-index: 10;
        width: 100%;
        // height: 1.6rem;
        padding: 0.3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p {
          margin: 0.15rem 0;
          color: #fcfdfd;
          font-size: 13px;
          line-height: 1;
        }
      }
    }
  }
  // .content {
  //   position: relative;
  //   top: 15px;
  //   // left: 2.16rem;
  //   // width: 100%;
  //   // height: 100%;
  //   .top {
  //     width: 599px;
  //     height: 55px;
  //     margin: 0 2rem;
  //     border: 2px solid #0583c9;
  //     border-radius: 5px;
  //     line-height: 55px;
  //     background: rgba(5, 131, 201, 1);
  //     display: flex;
  //     font-size: 0.5rem;
  //     font-family: SourceHanSansSC;
  //     font-weight: bold;
  //     color: #ffffff;
  //     text-indent: 0.5rem;
  //   }
  //   .mid {
  //     display: flex;
  //     justify-content: space-between;
  //     margin: 0.5rem 2rem;
  //     width: 100%;

  //     .img {

  //       img {
  //           width: 100%;
  //          height: 100%;

  //       }
  //     }

  //     .mask_content {

  //        padding: 0 0.6rem;

  //     }
  //   }
  //       .line {
  //       width: 100%;
  //       height: 1px;
  //       background: #0583c9;
  //       border: .5px solid #0583c9;
  //     }
  //   .bottom {
  //     width: 100%;
  //     height: 19%;
  //     margin-bottom: 1.5rem;

  //     .img {

  //       width: 100%;

  //       margin: 1rem auto;

  //        img {
  //          width: 100%;
  //          height: 100%;

  //       }
  //     }
  //   }

  // }
}
</style>
